import React, { ChangeEvent, FC } from 'react';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { Button } from 'src/components/Button';
import { PasswordInput } from 'src/components/Forms/FormInputs/PasswordInput';
import {
  Form,
  InputsWrapper,
} from 'src/components/Forms/SetNewPasswordForm/styled';
import { useGoogleAnalytics } from 'src/hooks/useGoogleAnalytics';

export interface SetNewPasswordFormValues {
  password: string;
  repeatPassword: string;
}

interface SetNewPasswordFormProps {
  onSubmit: SubmitHandler<SetNewPasswordFormValues>;
  loading: boolean;
}

export const SetNewPasswordForm: FC<SetNewPasswordFormProps> = ({
  onSubmit,
  loading,
}) => {
  const { trackFormSubmit, trackFormStart } = useGoogleAnalytics();
  const {
    formState: { errors, isValid },
    setValue,
    handleSubmit,
    trigger,
  } = useFormContext<SetNewPasswordFormValues>();

  const handleFormStart = () => {
    trackFormStart('set_new_password', 'auth');
  };

  const handleFormSubmit = (data: SetNewPasswordFormValues) => {
    trackFormSubmit('set_new_password', 'auth');
    onSubmit(data);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === 'password') {
      trigger('repeatPassword');
    }

    setValue(name as keyof SetNewPasswordFormValues, value, {
      shouldValidate: true,
    });
  };

  return (
    <Form onSubmit={handleSubmit(handleFormSubmit)}>
      <InputsWrapper>
        <PasswordInput
          error={!!errors.password}
          helperText={errors.password?.message || ' '}
          label="Password"
          name="password"
          onChange={handleChange}
          onFocus={handleFormStart}
        />
        <PasswordInput
          error={!!errors.repeatPassword}
          helperText={errors.repeatPassword?.message || ' '}
          label="Repeat password"
          name="repeatPassword"
          onChange={handleChange}
        />
      </InputsWrapper>
      <Button
        variant="contained"
        type="submit"
        fullWidth
        disabled={!isValid}
        loading={loading}
      >
        Save
      </Button>
    </Form>
  );
};
